<button
  mat-menu-item
  modeClipboard
  [clipboardText]="datasetShareLink"
  [successToastMessage]="'Link to Dataset copied successfully'"
  data-test="copy-dataset-link"
>
  Copy Dataset link
</button>
<a href="#" (click)="viewOrPreviewDataset.emit()" mat-menu-item data-test="preview-dataset">View Dataset</a>

<button
  mat-menu-item
  [disabled]="isPersonal"
  (click)="handleUseInNewReport.emit()"
  data-test="use-dataset-in-new-report-context"
>
  Use in new Report
</button>

<ng-container *ngIf="canSaveCodeChanges">
  <mat-divider></mat-divider>

  <button mat-menu-item [disabled]="!isDirty" (click)="handleSave.emit()" data-test="save-code">
    <span>Save code changes</span>
    <span class="keyboard-shortcut">Ctrl/Cmd + S</span>
  </button>
  <button mat-menu-item *ngIf="canSyncToGithub" (click)="handleGithubSync.emit()" data-test="github-sync">
    Push changes to GitHub
  </button>
  <a mat-menu-item *ngIf="!!githubLink" [href]="githubLink" target="_blank" data-test="github-view">
    View changes in GitHub
  </a>
</ng-container>

<mat-divider></mat-divider>

<button
  *ngIf="publishOption"
  mat-menu-item
  (click)="publishOptionClicked.emit(publishOption)"
  [attr.data-test]="publishOption + '-dataset-button'"
>
  {{ publishOption }} Dataset...
</button>
<button mat-menu-item data-test="move-dataset">
  <ng-content select="[move-space]"></ng-content>
</button>
<button mat-menu-item data-test="rename-dataset">
  <ng-content select="[rename-report]"></ng-content>
</button>
<button mat-menu-item *ngIf="!modeStudioEnabled" data-test="active-schedule-button">
  <ng-content select="[manage-schedule]"></ng-content>
</button>
<div class="disabled-menu-item" *ngIf="modeStudioEnabled" mat-menu-item>
  <span class="disabled-schedule">Schedule...</span>
  <span
    class="tooltip-parent"
    capraTooltip
    tooltipContent="Schedules are only available on Mode Business plans. Upgrade to schedule your data on a cadence."
    [tooltipContentIsHtml]="true"
    tooltipPlacement="right"
    [tooltipOffset]="[15, 35]"
    [tooltipInteractive]="false"
    tooltipSize="large"
  >
    <capra-badge class="paid-badge" type="purple" text="PAID FEATURE" data-test="paid-feature-badge"> </capra-badge>
  </span>
</div>
<mat-divider></mat-divider>

<button mat-menu-item (click)="openDatasetDeletionModal()" data-test="delete-dataset">Delete Dataset</button>
